// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__tU2cO","title":"styles_title__sG7Rj"};